import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import * as _ from "lodash";

/**
 * Generated class for the CheckboxInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "checkbox-input",
  templateUrl: "checkbox-input.html",
})
export class CheckboxInputComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() config: any;

  // Internal data model
  id: string;
  componentId: string;
  label: any;
  innerGroup: FormGroup;
  configOptions: string[] = [];
  options: string[] = [];
  selected: string[] = [];
  details: any;

  requiredIfOtherEmpty: boolean;
  disabled: boolean;
  readonly: boolean = false;
  dynamicLabel: boolean;
  multiline: boolean;

  supportOther: boolean = false;
  supportOtherOverride: boolean;
  otherConfig: any;
  otherRules: any;
  maxLength: number;
  existingData: any;

  selectedCount: number = 0;

  columns: number;

  constructor(
    public formBuilder: FormBuilder,
    private translate: TranslateService
  ) {
    // console.log('Hello CheckboxInputComponent Component');
  }

  ngOnInit(): void {
    // console.log( "Checkbox input config: ", this.config );

    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;
    this.supportOther = this.config.supportOther;
    this.supportOtherOverride = this.config.supportOtherOverride;
    if (this.config.rules) {
      this.dynamicLabel = this.config.rules.dynamicLabel;
      this.multiline = this.config.rules.multiline;
    }
    this.requiredIfOtherEmpty =
      this.config.requiredIfOtherEmpty !== undefined
        ? this.config.requiredIfOtherEmpty
        : false;

    this.columns = this.config.columns;

    if (!this.config.options) {
      // console.error( "Cannot build checkbox input, no options found." );
    }

    this.group.addControl(this.id, this.formBuilder.control({}));
    this.innerGroup = this.formBuilder.group({});

    this.configOptions = this.config.options;
    this.options = this.configOptions.slice(0);
    this.details = this.config.details;
    for (let option of this.options) {
      this.innerGroup.addControl(option, this.formBuilder.control(false));
    }

    if (this.config.supportNoneOfTheAbove) {
      this.innerGroup.addControl(
        "noneOfTheAbove",
        this.formBuilder.control(false)
      );
    }

    if (this.supportOther || this.supportOtherOverride) {
      // console.log( "Supporting other field, adding control." );
      this.otherConfig = {
        id: "other",
        componentId: this.componentId + "Other",
        label: false,
        placeholder: this.config.otherPlaceholder || "other",
        rules: this.config.otherRules,
        readonly: this.readonly,
      };
    }

    this.existingData = this.group.controls[this.id].value || null;

    this.group.controls[this.id].valueChanges.subscribe((data) => {
      // console.log( "Outer group state changed:", data );
      // console.log( "Current form state: ", this.innerGroup );
      this.selected = data;
      let exisData = false;
      if (data && data.length === 0 && this.existingData !== null) {
        data = this.existingData;
        this.existingData = null;
        exisData = true;
      }

      let innerGroup = this.innerGroup;

      if (data === null) {
        let emptyVal = {};
        for (let control of Object.keys(innerGroup.controls)) {
          if (this.supportOther && control === "other") {
            emptyVal[control] = null;
          } else {
            emptyVal[control] = false;
          }
        }
        innerGroup.setValue(emptyVal);
      } else if (data && !this.checkCurrentState(data)) {
        let currentState = innerGroup.value;
        let configOptions = this.configOptions;
        for (let key of Object.keys(innerGroup.controls)) {
          if (
            configOptions.indexOf(key) == -1 &&
            data.indexOf(key) == -1 &&
            key !== "other" &&
            key != "noneOfTheAbove"
          ) {
            innerGroup.removeControl(key);
            this.options.splice(this.options.indexOf(key), 1);
            delete currentState[key];
          } else {
            if (this.supportOther && key == "other") {
              currentState[key] = null;
            } else {
              currentState[key] = false;
            }
          }
        }

        if (!exisData) {
          for (let key of data) {
            if (currentState[key] == undefined) {
              this.options.push(key);
              innerGroup.addControl(key, this.formBuilder.control(true));
              innerGroup.controls[key].valueChanges.subscribe((data) => {
                if (data == false) {
                  this.options = this.options.filter(
                    (option) => option !== key
                  );
                  innerGroup.removeControl(key);
                }
              });
            }
            if (this.disabled || this.readonly) {
              innerGroup.controls[key].disable({ emitEvent: false });
            }
            currentState[key] = true;
          }
          // if (this.supportOther || this.supportOtherOverride) {
          //   currentState['other'] = '';
          // }
        }
        innerGroup.setValue(currentState);
      }

      this.toggleControlDisable();
    });

    this.innerGroup.valueChanges.subscribe((data) => {
      if (this.supportOther) {
        delete data["other"];
      }
      let values = this.getValueArray(data);
      this.group.controls[this.id].setValue(values);
      this.selectedCount = values.length;
      this.group.markAsDirty();

      this.group.controls[this.id].setErrors(this.getErrors());
    });
    if (this.config.supportNoneOfTheAbove) {
      this.innerGroup.controls["noneOfTheAbove"].valueChanges.subscribe(
        (data) => {
          if (data) {
            for (let option of this.options) {
              this.innerGroup.controls[option].setValue(false);
              this.innerGroup.controls[option].disable();
            }
          } else {
            for (let option of this.options) {
              if (!this.disabled && !this.readonly) {
                this.innerGroup.controls[option].enable();
              }
            }
          }
        }
      );
    }

    this.toggleControlDisable();

    this.group.controls[this.id].setValue(this.group.controls[this.id].value);
  }

  toggleControlDisable(): void {
    let outerDisabled = this.group.controls[this.id].disabled;
    if (outerDisabled !== this.disabled) {
      this.disabled = outerDisabled;
      if (this.disabled || this.readonly) {
        this.innerGroup.disable({ emitEvent: false });
      } else {
        this.innerGroup.enable({ emitEvent: false });
      }
    }
    this.disabled = this.group.controls[this.id].disabled;
  }

  ngAfterViewInit(): void {
    this.group.controls[this.id].setErrors(this.getErrors());
    // Errors can get lost when manually set
    // This is an overzealous approach to guarantee they get maintained
    this.group.valueChanges.subscribe((data) => {
      this.group.controls[this.id].setErrors(this.getErrors());
    });
  }

  addOther() {
    let otherVal = "" + this.innerGroup.controls["other"].value;
    if (!_.isEmpty(otherVal.trim())) {
      //prevent adding duplicates
      if (
        this.options.filter(
          (option) =>
            //get the translation, compare to otherVal
            this.translate.instant(option).toString().toLowerCase() ===
            otherVal.toLowerCase()
        ).length > 0
      ) {
        return;
      }
      if (this.otherConfig.rules) {
        if (this.otherConfig.rules.maxLength) {
          if (otherVal.length < this.otherConfig.rules.maxLength) {
            this.setOtherValue(otherVal);
          }
        } else {
          this.setOtherValue(otherVal);
        }
      } else {
        if (otherVal.length) {
          this.setOtherValue(otherVal);
        }
      }
    }
  }

  setOtherValue(otherVal: string) {
    this.options.push(otherVal);
    this.innerGroup.addControl(otherVal, this.formBuilder.control(true));
    this.innerGroup.controls[otherVal].valueChanges.subscribe((data) => {
      console.log(0);
      if (data == false) {
        this.options = this.options.filter((option) => option !== otherVal);
        this.innerGroup.removeControl(otherVal);
      }
    });

    this.innerGroup.controls["other"].setValue("");
  }

  getValueArray(data: object) {
    let valArray: string[] = [];
    for (let key of Object.keys(data)) {
      if (data[key]) {
        valArray.push(key);
      }
    }
    // console.log( "Determined value array: ", valArray );
    return valArray;
  }

  checkCurrentState(data: string[]): boolean {
    let valArray = this.getValueArray(this.innerGroup.value);

    if (valArray.length !== data.length) {
      return false;
    }

    let numInconsistent = valArray.filter((val) => {
      data.indexOf(val) == -1;
    }).length;

    return numInconsistent == 0;
  }

  getErrors(): ValidationErrors {
    let errors = {};
    if (
      this.config?.rules?.required &&
      this.getValueArray(this.innerGroup.value).length === 0
    ) {
      errors["required"] = true;
    }
    // console.log( "Determined checkbox errors:", errors );
    return Object.keys(errors).length == 0 ? undefined : errors;
  }

  showError(id) {
    return (
      this.group.controls[id].errors &&
      (this.group.touched || this.group.dirty) &&
      !(this.disabled || this.readonly)
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/checkbox-input/checkbox-input.ts